// ***** use for set token in headers request to api ******
//                     ************
import axios from 'axios';
const baseURL = process.env.REACT_APP_BASE_API_URL
// const baseURL ="http://192.168.8.123:8003/api/v1/"

const token = localStorage.getItem("token");
// const token = Bearertoken ? true : false;

const Axios = axios.create({
    baseURL,
    // timeout: 15000,
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
    },
});

Axios.interceptors.request.use(async (config) => {
    const token = await localStorage.getItem('token');
    const isLoggedIn = token ? true : false;
    config.headers = {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        // add auth header with jwt if account is logged in and request is to the api url
        ...(isLoggedIn && {
            Authorization: `Bearer ${token}`
        })
    }
   
    return config
}, error => Promise.reject(error))
export default Axios;